<script>
import {mapState} from "vuex";
import {EF_TRACKING_URL} from "@/paths/constants";

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    }
  },

  data() {
    return {
      loading: false,
      email: "",
      emailErrorMsg: "",
      emailError: false,
      emptyEmailFieldError: false,
      invalidEmailFieldError: false,
      changeEmailError: false,
    };
  },


  computed: {
    ...mapState([
      'fields',
      'fieldsFromUrl',
      'fieldsFromStorage',
      ]),
  },

  async created() {
    if (this.prepare) {
      if (!(this.fieldsFromUrl["email"] === undefined)) {
        this.email = this.fieldsFromUrl["email"];
      } else if (!(this.fieldsFromStorage['email'] === undefined)) {
        this.email = this.fieldsFromStorage["email"];
      }

      if (!(this.fieldsFromUrl["user_email"] === undefined)) {
        this.email = this.fieldsFromUrl["user_email"];
      } else if (!(this.fieldsFromStorage['user_email'] === undefined)) {
        this.email = this.fieldsFromStorage["user_email"];
      }

      const valid = await this.validate();

      if (!valid) {
        this.$emit('show-this-step')
      } else {
        await this.setAnswer()
      }
    }

  },

  methods: {
    async setAnswer() {
      this.loading = true
      const valid = await this.validate();

      if (!valid) {
        this.loading = false
        return false
      }

      await this.$store.dispatch("setAnswers", [
        {
          field: "email",
          value: this.email,
        },
      ]);
      this.$emit("next-step");
      // await this.progressionTracking();
    },

    async ipqsEmailValidation() {
      const ipqsURL = "https://validations.org31415.dev/api/validations/ipqs/email"
      const response = await this.axios.post(ipqsURL, {
        email: this.email
      })
      this.requestId = response.data.request_id

      if (!response.data.valid) {
        this.emailError = true
        this.invalidEmailFieldError = true
        return false
      } else if (response.data.disposable) {
        this.emailError = true
        this.invalidEmailFieldError = true
        return false
      } else if(response.data.fraud_score > 90) {
        this.emailError = true
        this.changeEmailError = true
        return false
      }
      return true
    },

    async validate() {
      if (!this.email || this.email.length === 0) {
        this.emailError = true
        this.emptyEmailFieldError = true
        return false
      }

      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const valid = re.test(String(this.email).toLowerCase());

      if (!valid) {
        this.emailError = true
        this.invalidEmailFieldError = true
        return false
      }

      const validRemote = await this.ipqsEmailValidation()
      if (!validRemote) {
        // await this.failurePostBack()
        return false
      }
      return true
    },

    async failurePostBack() {
      const eventID = this.customProps.trackFailure ? "75" : "77"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}&adv1=${this.requestId}`)
    },

    async progressionTracking() {
      const eventID = this.customProps.trackProgress ? "42" : "63"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}`)
    },

    handleInputChange() {
      this.emailError = false
      this.emptyEmailFieldError = false
      this.invalidEmailFieldError = false
      this.changeEmailError = false
    },
  }
};
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">
          Where can a licensed agent send an insurance recommendation?
          <span class="is-block subtitle-question">Don't worry, no spam.</span>
        </h2>
        <form
          class="container is-max-widescreen"
          @submit.prevent="setAnswer('Continue')"
        >
          <b-field
            class="has-text-left"
            :type="emailError ? 'is-danger' : ''"
            :message="[
              { 'Please fill out this field.': emptyEmailFieldError },
              { 'Please enter a valid email address.': invalidEmailFieldError },
              { 'Please input a different email address.': changeEmailError },
            ]"
          >
            <b-input
              class="mt-5"
              v-model.trim="email"
              type="text"
              placeholder="Enter Email Address"
              :loading="loading"
              @input="handleInputChange"
            >
            </b-input>
          </b-field>
          <input
            type="submit"
            value="Continue"
            class="input submitButton mt-5 input-submit"
            :disabled="loading"
          />
        </form>
      </div>
    </div>
  </div>
</template>
